import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import {
  initialiseClientGlobalSagas,
  initialiseGlobalReducer,
  setApplicationBootStrapActions,
  setGlobalPageTransitionActions,
} from '@fil-global/eiswagen';

import { globalActions, globalPageTransitionActions } from './global/actions';
import globalReducer from './global/reducer';
import globalSagas from './global/sagas';
import App from './App';

initialiseGlobalReducer(globalReducer);
initialiseClientGlobalSagas(globalSagas);
setApplicationBootStrapActions(globalActions);
setGlobalPageTransitionActions(globalPageTransitionActions);

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
